import { resourcesLanguageItalian } from '@ragu-components/ord-providers';

import type { UserResourcesTranslationMessages } from './userResourcesTranslationMessages';

export const userResourcesLanguageItalian: UserResourcesTranslationMessages = {
  users: {
    name: 'Utenti',
    fields: {
      ...resourcesLanguageItalian.users.fields,
      id: 'ID',
      email: 'Email',
      mappings: 'Mapping',
      password: 'Password',
      username: 'Nome Utente',
      firstname: 'Nome',
      middlename: 'Secondo Nome',
      lastname: 'Cognome',
      language: 'Lingua',
      timezone: 'Fuso Orario',
      sessionexpire: 'Durata Sessione',
      account_status: 'Stato Account',
      account_disabled: 'Disabilitato',
      account_enabled: 'Abilitato',
      enabling: 'Abilitazione Account',
      acl_resources: 'Permessi',
      last_access_at: 'Ultimo Accesso',
      password_last_change_at: 'Ultimo Cambio Password',
      required_actions: 'Azioni Richieste',
      required_actions_values: {
        change_pass: 'Cambio password',
        configure_totp: 'Configurazione TOTP',
      },
      acl_labels: { bulkUpdateLabel: 'Label Acl' },
      labels: { name: 'Etichette', id: 'Etichette' },
      groups: { name: 'Gruppi' },
      totp_enabled: 'TOTP abilitato',
      totp_last_used_at: 'Ultimo utilizzo TOTP',
      service_class: 'Service class',
      metadata: {
        identification_number: 'Numero di identificazione',
        shared_pause: 'Pausa condivisa',
        call_forwarding_rules: 'Regole di inoltro delle chiamate',
        can_access_own_recordings: 'Può accedere alle proprie registrazioni',
        recall_enabled: 'Può usare il servizio di richiamata',
        ai_voice_analysis_inbound: 'Verifica voce falsa sulle chiamate esterne entranti',
        ai_voice_analysis_outbound: 'Verifica voce falsa sulle chiamate esterne uscenti',
      },
      photo: {
        name: 'Immagine del profilo',
        description: 'Carica immagine del profilo. La dimensione massima è di 1MB.',
        current: 'Immagine del profilo attuale',
        too_large: 'Immagine del profilo troppo grande',
        invalid: 'Immagine del profilo non valida',
      },
      assigned_lcr: 'LCR',
    },
    operations: {
      create: 'Crea utente',
      delete: "Elimina l'utente",
      edit: 'Modifica utente',
      sections: {
        personalData: 'Anagrafica',
        userSettings: 'Impostazioni',
        permissions: 'Permessi',
      },
      genPassword: 'Genera password sicura',
    },
    helperTexts: {
      sessionexpire:
        "Timeout di sessione dell'utente, in secondi, utilizzato per far scadere automaticamente l'autenticazione dell'utente ad alcuni servizi",
      acl_labels: 'Elenco di etichette ACL per questo utente',
      recall_enabled:
        "Il servizio di richiamata permetterà all'utente selezionato di prenotare una richiesta di richiamata verso un interno locale, se la chiamata verso l'interno non va a buon fine",
      identification_number:
        "Numero identificativo annunciato quando l'opzione 'annuncia agente' è abilitata nelle impostazioni della coda",
      shared_pause:
        "Indica se l'utente può utilizzare il servizio di richiamata automatica (prenotare richiamate automatiche per chiamate non riuscite verso altri utenti interni)",
      ai_voice_analysis_inbound:
        "Esegue la verifica AI della voce dell'interlocutore remoto sulle chiamate entranti verso questo utente provenienti dall'esterno del centralino. Richiede che il token API Realynx sia configurato sul dominio",
      ai_voice_analysis_outbound:
        'Esegue la verifica AI della voce del chiamato sulle chiamate esterne effettuate da questo utente. Richiede che il token API Realynx sia configurato sul dominio',
    },
  },
  owner: {
    name: 'Proprietario',
  },
  groups: {
    name: 'Gruppi',
    fields: {
      id: 'ID',
      users: 'Utenti',
      labels: { id: 'Etichette', name: 'Etichette' },
      description: 'Descrizione',
      acl_labels: 'Etichette ACL',
      acl_resources: 'Risorse ACL',
      name: 'Nome gruppo',
      number: 'Numero di pickup',
    },
    operations: {
      create: 'Crea gruppo',
      delete: 'Elimina il gruppo',
      edit: 'Modifica gruppo',
      sections: {
        groupsInfo: 'Info gruppo',
        permissions: 'Permessi',
      },
    },
    helperTexts: {
      acl_labels: 'Elenco di etichette ACL per questo gruppo',
      number: 'Se impostato, il gruppo può essere utilizzato come gruppo di pickup',
    },
  },
  extensions: {
    name: 'Estensioni',
    fields: {
      id: 'ID',
      labels: { id: 'Etichette', name: 'Etichette' },
      number: 'Numero',
      ringtime: 'Durata squillo',
      user: 'Utente',
    },
    operations: {
      create: 'Crea estensione',
      delete: 'Elimina estensione',
      edit: 'Modifica estensione',
      sections: {
        details: 'Dettagli estensione',
      },
    },
    helperTexts: {
      number: 'Numero di estensione, quello che deve essere chiamato per raggiungere il dispositivo',
      ringtime: 'Durata dello squillo in secondi',
    },
  },
  sip_identities: {
    name: 'Identità SIP',
    fields: {
      id: 'ID',
      assigned_sip_profile: 'Profilo SIP',
      extension: 'Estensione',
      labels: { id: 'Etichette', name: 'Etichette' },
      password: 'Password SIP',
      user: 'Utente',
      username: 'Nome Utente',
      device_types: 'Tipi di dispositivo',
      enum_device_types: {
        mobile: 'Mobile',
        chat: 'Chat',
        desktop: 'Desktop',
        phone: 'Phone',
        web: 'Web',
      },
    },
    operations: {
      create: "Crea un'identità SIP",
      delete: 'Elimina identità SIP',
      edit: 'Modifica identità SIP',
      sections: {
        details: 'Dettagli identità SIP',
      },
      genPassword: 'Genera password SIP sicura',
    },
    helperTexts: {
      username: "Nome utente dell'identità SIP, usato per registrarsi al sistema",
      password: "Password dell'identità SIP, utilizzata per registrarsi al sistema",
    },
    errors: {
      usernameAlreadyExists: 'Questo nome utente è già in utilizzo da un altra identità SIP',
    },
  },
  hunting_groups: {
    name: 'Gruppi di hunting',
    fields: {
      id: 'ID',
      name: 'Nome',
      description: 'Descrizione',
      labels: { id: 'Etichette', name: 'Etichette' },
      owner: 'Proprietario',
      user_numbers: 'Numeri utente',
    },
    operations: {
      create: 'Crea gruppo di hunting',
      delete: 'Elimina gruppo di hunting',
      edit: 'Modifica gruppo di hunting',
      sections: {
        details: 'Dettagli gruppo di hunting',
      },
    },
    helperTexts: {
      owner: "L'utente associato a questo gruppo di hunting, che è anche il suo proprietario",
    },
  },
  user_numbers: {
    name: 'Numeri utente',
    fields: {
      id: 'ID',
      description: 'Descrizione',
      labels: { id: 'Etichette', name: 'Etichette' },
      number: 'Numero',
      owner: 'Proprietario',
    },
    operations: {
      create: 'Crea numero utente',
      delete: 'Elimina numero utente',
      edit: 'Modifica numero utente',
      sections: {
        details: 'Dettagli numero utente',
      },
    },
    helperTexts: {
      owner: "L'utente associato a questo numero, che è anche il suo proprietario",
    },
  },
  voicemails: {
    ...resourcesLanguageItalian.voicemails,
    name: 'Segreteria telefonica',
    settingButtonLabel: 'Configura',
    fields: {
      labels: { id: 'Etichette', name: 'Etichette' },
      preferences: {
        enabled: 'Attivata',
        pin: 'PIN',
        quota: 'Quota (secondi)',
      },
    },
    helperTexts: {
      notConfigured:
        'Nessuna impostazione di segreteria telefonica. Abilita la modifica per creare una configurazione.',
      settingsNotConfigured:
        'La segreteria telefonica non è configurata per il tuo account. Contatta un amministratore per abilitarla',
    },
    actions: {
      enable: 'Configura impostazioni segreteria telefonica',
    },
    notifications: {
      loading: 'Caricamento delle impostazioni della segreteria telefonica...',
      fetchError: 'Impossibile caricare le impostazioni della segreteria telefonica',
      createSuccess: 'Impostazioni della segreteria telefonica create',
      updateSuccess: 'Impostazioni della segreteria telefonica aggiornate',
      updateError: 'Impossibile salvare le impostazioni della segreteria telefonica',
      requestError: 'Impossibile recuperare le impostazioni della segreteria telefonica',
    },
    validation: {
      pin: 'Il PIN deve contenere da 4 a 10 cifre',
    },
  },
  conferences: {
    name: 'Conferenze',
  },
  distribution_lists: {
    name: 'Liste di distribuzione',
    operations: {
      create: 'Crea lista di distribuzione',
      delete: 'Elimina lista di distribuzione',
      edit: 'Modifica lista di distribuzione',
      sections: {
        details: 'Dettagli lista di distribuzione',
      },
    },
  },
  contacts: resourcesLanguageItalian.contacts,
  user_import: {
    name: 'Importa utenti',
    fields: {
      overwrite: 'Sovrascrivere gli utenti esistenti su match',
      fileUploadHint: 'Fare clic o trascinare un file qui per caricare un file CSV',
    },
    operations: {
      create: 'Importa utenti',
      delete: 'Elimina importazione',
    },
    notifications: {
      created: 'Operazione di importazione utenti creata',
    },
  },
  tasks: {
    name: 'Attività',
    actions: {
      download: 'Scarica',
      downloadBackup: 'Scarica Backup',
    },
    fields: {
      id: 'ID',
      type: 'Tipo',
      created_at: 'Creato il',
      status: 'Stato',
      statuses: {
        starting: 'Avvio',
        running: 'In esecuzione',
        error: 'Errore',
        done: 'Completato',
      },
      result: {
        detail: 'Dettaglio',
        title: 'Risultato',
        backupReady: 'Il backup per il dominio %{realm} è pronto per il download.',
        backupImportDone: 'Importazione completata',
        backupImportSuccess: 'Il backup è stato importato correttamente nel dominio %{realm}.',
      },
    },
    enums: {
      type: {
        users_import: 'Importazione utenti',
        users_export: 'Esportazione utenti',
        backup_import: 'Importazione backup',
        backup_export: 'Esportazione backup',
        contacts_import: 'Importazione contatti',
        contacts_export: 'Esportazione contatti',
      },
    },
  },
  autoprovisioning: {
    authentication: {
      name: 'Autenticazione',
      settingButtonLabel: 'Configura',
      description:
        'Quando disabilitata, i dispositivi AP possono effettuare il provisioning automatico senza credenziali per la durata specificata.',
      status: { enabled: 'Abilitata', disabled: 'Disabilitata' },
      fields: { duration: 'Durata (secondi)', expires_at: 'Scade il', enabled: 'Stato' },
      disableSection: 'Apri finestra di autenticazione',
      actions: { enable: 'Abilita', disable: 'Disabilita' },
      notifications: {
        enableSuccess: 'Autenticazione abilitata',
        enableError: "Errore nell'abilitazione dell'autenticazione",
        disableSuccess: 'Autenticazione disabilitata',
        disableError: "Errore nella disabilitazione dell'autenticazione",
        fetchError: 'Errore nel caricamento delle impostazioni',
      },
    },
    settings: {
      name: 'Impostazioni',
      fields: {
        outbound_proxy: 'Proxy outbound',
        outbound_backup_proxy: 'Proxy outbound di backup',
      },
      notifications: {
        saveSuccess: 'Impostazioni salvate',
        saveError: 'Errore nel salvataggio delle impostazioni',
        fetchError: 'Errore nel caricamento delle impostazioni',
      },
    },
  },
};
